
export const enum CarPositionsEnum {
  FRONT_LEFT = 'FRONT_LEFT',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  FRONT_RIGHT = 'FRONT_RIGHT',
}

export interface AngularPhotoType {
  code: CarPositionsEnum
  labelTxt: string,
  imgSrc?: any,
  liqDescription?: string
}
